module.exports = __webpack_public_path__ + "img/logo.63b9a2d3.png";